require([
    "MediaGallery/mediaGallery"
],
    function (mediaGallery) {

        window.backButtonClickedFromPhotoSwipe = false;

        function initAllMediaGalleriesOnPage() {
            // process all swipers that make up media galleries
            $(mediaGallery.swiperSelector).each(function (index, swiperContainer) {               
                // initialize accompanying thumbs swiper
                var thumbsSwiper = null;
                var thumbsContainer = $(swiperContainer).closest(mediaGallery.mediaGallerySelector).find(mediaGallery.thumbsSelector);
                if (thumbsContainer.length) {
                    thumbsSwiper = initializeSwiper(thumbsContainer[0], null, true);
                }
                // intialize main swiper
                var swiper = initializeSwiper(swiperContainer, thumbsSwiper);
                swiper.on("slideChange", function () { mediaGallery.displayCaptionForCurrentSlide(this); });

                // if first slide is video it will not display swiper, because videos are hidden by default, we need to go to first visible slide
                //var slides = swiper.slides;
                //if (slides && slides.length) {
                //    for (var i = 0; i < slides.length; i++) {
                //        var slide = slides[i];
                //        if ($(slide).hasClass("d-none")) continue;
                //        swiper.slideTo(i);
                //        break;
                //    }
                //}

                //swiper.on("zoomChange", onZoomChange);   not using the zoom icons any more
            });
            // ZOOM ICONS FUNCTIONALITY
            //$(mediaGallery.mediaGallerySelector).find(".zoom-icon i").off("click").on("click", toggleZoom); not using the zoom icons any more

            // Media Gallery popup functionality
            $('.media-gallery .main .swiper-slide').off('click').on('click', function (e) {
                if ($(".modal-gallery").hasClass("open-modal")) {
                    //toggleZoom(e);    not using this way of activating zoom any more
                } else {                          
                    var swiperElement = $(this).closest(mediaGallery.swiperSelector);
                    if (swiperElement && swiperElement.length) {
                        e.data = {};
                        e.data.galleryNumber = $(swiperElement).attr("id").replace("media_gallery_swiper_", "");
                    }
                    mediaGallery.displayGalleryPopup(e);
                }
            });
            $('.popup .close').off('click').on('click', mediaGallery.closeGalleryPopup);

            $("body").off('click').on('click', function (e) {
                //check if we click inside popup
                //if it is click inside popup, don't do anything
                const isInsidePopup = e.target.closest(".popup");                
                if (!isInsidePopup && $(".modal-gallery").hasClass("open-modal"))
                    mediaGallery.closeGalleryPopup();
            });

            $(document).on('keydown', function (event) {
                if (event.key == "Escape") {
                    if ($(".modal-gallery").hasClass("open-modal"))
                        mediaGallery.closeGalleryPopup();
                }
            });

            // EasyZoom and PinchZoom init
            mediaGallery.initZoomAndPinch();
        }

        function initializeSwiper(swiperContainer, accompanyingThumbsSwiper, isThumbs) {
            var data = $(swiperContainer).data();
            var swiperParameters = {
                loop: false,
                slidesPerView: data.numberOfVisibleSlides ? data.numberOfVisibleSlides : 'auto',
                spaceBetween: 20,
                lazy: !isThumbs,
                freeMode: isThumbs,
                watchSlidesVisibility: isThumbs,
                watchSlidesProgress: isThumbs,
                thumbs: { swiper: accompanyingThumbsSwiper },
                zoom: true,

                // Image loaded event
                on: {
                    lazyImageReady: function (slideEl, imageEl) {
                        //setTimeout(function () {
                            if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                                //if (!$(".modal-gallery").hasClass("open-modal") && data.zoomLevel > 0) {
                                //    $(slideEl).find('.easyzoom').EasyZoomMagnifier();
                                //}
                            }
                        //}, 1000);
                    }
                },

                // Pagination
                pagination: {
                    el: '#' + $(swiperContainer).attr('id') + ' .swiper-pagination',
                    clickable: true
                },

                // Navigation arrows
                navigation: {
                    nextEl: '#' + $(swiperContainer).attr('id') + ' .swiper-button-next',
                    prevEl: '#' + $(swiperContainer).attr('id') + ' .swiper-button-prev'
                }
            };
            if (data.zoomLevel > 0) {
                swiperParameters.zoom = { maxRatio: data.zoomLevel };
            } else {
                swiperParameters.zoom = false;
            }
            if (swiperParameters.slidesPerView !== 'auto') {
                // reduce number of visible slides on smaller screens
                swiperParameters.breakpoints = {
                    1024: {
                        slidesPerView: (data.numberOfVisibleSlides - 1) > 0 ? (data.numberOfVisibleSlides - 1) : 1
                    },
                    768: {
                        slidesPerView: (data.numberOfVisibleSlides - 2) > 0 ? (data.numberOfVisibleSlides - 2) : 1
                    }
                    /* 640: {
                        slidesPerView: (data.numberOfVisibleSlides - 3) > 0 ? (data.numberOfVisibleSlides - 3) : 1
                    },
                    320: {
                        slidesPerView: (data.numberOfVisibleSlides - 4) > 0 ? (data.numberOfVisibleSlides - 4) : 1
                    }
                    */
                };
            }
            if (data.autoplaySeconds) {
                swiperParameters.autoplay = { delay: data.autoplaySeconds * 1000 };
            }
            // We are using now Photo Swipe and it has zooming, because of that we don't need zooming in swiper
            swiperParameters.zoom = { enabled: false };
            var swiper = new Swiper(swiperContainer, swiperParameters);

            return swiper;
        }

        /* not using the zoom icons any more
        function onZoomChange(scale, imageEl, slideEl) {
            // set the zoom icon correctly if we've zoomed in/out using standard Swiper functionality
            var zoomIconElement = $(slideEl).closest(mediaGallery.mediaGallerySelector).find(".zoom-icon");
            if (scale === 1) {
                $(zoomIconElement).find(".zoom-in").removeClass("d-none");
                $(zoomIconElement).find(".zoom-out").addClass("d-none");
            } else {
                $(zoomIconElement).find(".zoom-in").addClass("d-none");
                $(zoomIconElement).find(".zoom-out").removeClass("d-none");
            }
        }

        function toggleZoom(event) {
            // this == the icon that was clicked
            var swiperContainer = $(this).closest(mediaGallery.mediaGallerySelector).find(mediaGallery.swiperSelector);
            if (swiperContainer.length) {
                var swiper = swiperContainer[0].swiper;
                if (swiper) {
                    swiper.zoom.toggle();
                }
            }
        }
        */

        initAllMediaGalleriesOnPage();
        
        $(window).bind("popstate", function (event) {             
            var isMob = window.isMobile();           
            if (!isMob) { return; }
            //check if PhotoSwipe is already opened
            var photoSwipeOpened = $(".pswp--open");
            var isPhotoSwipeOpened = photoSwipeOpened && photoSwipeOpened.length;    
            if (isPhotoSwipeOpened) {
                var lightbox = window.lightbox;
                if (lightbox && lightbox.pswp) {   
                    if (window.closingPopstate) return;
                    window.backButtonClickedFromPhotoSwipe = true;  
                    $(".pswp__button--close").trigger("click");                    
                }
            }
            else
                return;
        });  

        window.isMobile = function() {
            return ('ontouchstart' in document.documentElement) && (/Mobi/.test(navigator.userAgent));
        }
    }
);

define("MediaGallery/main", function(){});

